<template>
  <b-modal
    id="modal-como-se-calcula"
    title="¿Cómo se calculan los Días Libres?"
    ok-only
    ok-title="Entendido"
    ok-variant="primary"
    modal-class="modal-info"
    centered
  >
    <div class="p-1">
      <p class="text-muted">
        El control mensual de días libres se calcula automáticamente a partir de la asistencia, el régimen laboral y los movimientos del conductor:
      </p>

      <ul class="list-unstyled mt-1">
        <li class="d-flex align-items-start mb-1">
          <feather-icon icon="CheckCircleIcon" class="text-primary mr-1 mt-25" size="18" />
          <div>
            <strong>Días Meta (Generados):</strong>
            <p class="mb-0 text-muted small">
              Se calculan según el tipo de régimen asignado al conductor (ej. Régimen 23x2 genera 2 días al mes, 6x1 genera 4 días al mes).
            </p>
          </div>
        </li>

        <li class="d-flex align-items-start mb-1">
          <feather-icon icon="SunIcon" class="text-success mr-1 mt-25" size="18" />
          <div>
            <strong>Días Tomados:</strong>
            <p class="mb-0 text-muted small">
              Días libres efectivamente gozados por el conductor durante el mes, registrados en el tareo de asistencia.
            </p>
          </div>
        </li>

        <li class="d-flex align-items-start mb-1">
          <feather-icon icon="DollarSignIcon" class="text-warning mr-1 mt-25" size="18" />
          <div>
            <strong>Días Vendidos:</strong>
            <p class="mb-0 text-muted small">
              Días compensados económicamente mediante solicitud aprobada y generada en caja de tesorería.
            </p>
          </div>
        </li>

        <li class="d-flex align-items-start mb-1">
          <feather-icon icon="MinusCircleIcon" class="text-danger mr-1 mt-25" size="18" />
          <div>
            <strong>Días Perdidos:</strong>
            <p class="mb-0 text-muted small">
              Días que se descuentan del acumulado por concepto de permisos particulares no compensables o faltas injustificadas.
            </p>
          </div>
        </li>

        <li class="d-flex align-items-start">
          <feather-icon icon="CalendarIcon" class="text-info mr-1 mt-25" size="18" />
          <div>
            <strong>Saldo Acumulado:</strong>
            <p class="mb-0 text-muted small">
              <code>Saldo Anterior + Meta - Tomados - Vendidos - Perdidos + Ajustes</code>. Si el saldo es negativo, indica que el conductor gozó más días de los que generó.
            </p>
          </div>
        </li>
      </ul>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "ComoSeCalculaModal",
};
</script>
